import { Link } from "react-router-dom";
import { useState } from "react";

function Navbar(){
    const [open, setOpen] = useState(false);

    return (
        <nav className="bg-primary text-white p-4">
            <div className="max-w-6xl mx-auto flex justify-between items-center">
                <Link to="/" className="flex items-center space-x-2">
                <img src="/logo3.png" alt="Logo" className="h-14 w-auto" />
                <span className="text-xl font-bold hidden sm:inline">Jake’s RV Repair & Maintenance</span>
                </Link>
                <button
                    className="sm:hidden text-white"
                    onClick={() => setOpen(!open)}
                >
                    ☰
                </button>
                <div className={`flex-col sm:flex sm:flex-row sm:items-center ${open ? "flex" : "hidden"} sm:space-x-6`}>
                    <Link to="/" className="block mt-2 sm:mt-0 hover:underline">Home</Link>
                    <Link to="/gallery" className="block mt-2 sm:mt-0 hover:underline">Gallery</Link>
                    <Link to="/about" className="block mt-2 sm:mt-0 hover:underline">About Us</Link>
                    <Link to="/contact" className="block mt-2 sm:mt-0 hover:underline">Contact</Link>
                    {/* Future pages: Schedule? */}
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
